import {
  IJwtApiKey,
  JwtTokenFullData,
  getJwtTokenFullDataFromApiKey,
} from 'multirpc-sdk';

import { decryptJWT } from './decryptJWT';

const decodedJWTsCache: Record<string, JwtTokenFullData> = {};

export interface DecodeJWTParams {
  isEncrypted: boolean;
  token: string;
  // present when the backend has already converted the JWT
  apiKey?: IJwtApiKey;
}

export const decodeJWT = async ({
  apiKey,
  isEncrypted,
  token,
}: DecodeJWTParams) => {
  if (decodedJWTsCache[token]) {
    return decodedJWTsCache[token];
  }

  const decodedJWT =
    getJwtTokenFullDataFromApiKey({ api_key: apiKey, jwt_data: token }) ??
    (await decryptJWT(token, isEncrypted));

  decodedJWTsCache[token] = decodedJWT;

  return decodedJWT;
};
